import { ExportColumn } from '../types';
import { DEFAULT_EXPORT_COLUMN_OPTIONS } from '../constants';

export const mergeExportColumns = (
  nextColumns: ExportColumn[],
  existingColumns: ExportColumn[]
): ExportColumn[] => {
  if (nextColumns.length === 0) {
    return existingColumns;
  }

  const nextByName = new Map(
    nextColumns.map((column) => [column.name, column])
  );
  const existingNames = new Set(existingColumns.map((column) => column.name));

  const mergeColumn = (
    nextColumn: ExportColumn,
    existingColumn?: ExportColumn
  ): ExportColumn => ({
    ...nextColumn,
    selected: existingColumn?.selected ?? nextColumn.selected,
    exportOptions:
      existingColumn?.exportOptions ??
      nextColumn.exportOptions ??
      DEFAULT_EXPORT_COLUMN_OPTIONS,
  });

  // Preserve the user's column order; append columns added by the new definition.
  const ordered = existingColumns
    .filter((column) => nextByName.has(column.name))
    .map((column) => mergeColumn(nextByName.get(column.name)!, column));

  const added = nextColumns
    .filter((column) => !existingNames.has(column.name))
    .map((column) => mergeColumn(column));

  return [...ordered, ...added];
};
